<script setup lang="ts">
defineProps<{
  title?: string
}>()
</script>

<template>
  <div v-if="title"
       class="bx-header__navi-group-headline">
    {{ title }}
  </div>
</template>
